import React from 'react';
import { getId } from '@fluentui/react';
import { DetailsContentContainer } from './DetailsContentContainer';
import { DetailsSummary } from './DetailsSummary';
import { useDetails } from './useDetails';

interface IDetailsProps {
  readonly title: string;
}

/**
 * Expandable component that contains details that explain specific functionality.
 */
export const Details: React.FC<IDetailsProps> = ({ title, children }) => {
  const [isExpanded, onClick] = useDetails();
  const actionButtonId = getId();
  const contentId = getId();

  return (
    <>
      <DetailsSummary
        title={title}
        isExpanded={isExpanded}
        actionButtonId={actionButtonId}
        contentId={contentId}
        onClick={onClick}
      />
      {isExpanded && (
        <DetailsContentContainer contentId={contentId} actionButtonId={actionButtonId}>
          {children}
        </DetailsContentContainer>
      )}
    </>
  );
};
